import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import fetchData from "../../api/fetchApi";
import PageHeader from "../common/PageHeader";

const StatusPill = ({ status }) => {
  let colorClasses = "bg-gray-100 text-gray-800 border-gray-200";
  if (status === "failed") {
    colorClasses = "bg-red-50 text-red-700 border-red-200";
  } else if (status === "pending") {
    colorClasses = "bg-yellow-50 text-yellow-700 border-yellow-200";
  } else if (status === "paid" || status === "completed" || status === "succeeded") {
    colorClasses = "bg-green-50 text-green-700 border-green-200";
  }

  return (
    <span className={`inline-flex items-center gap-1.5 text-xs px-2 py-1 rounded-full border ${colorClasses}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${
        status === "failed" ? "bg-red-500" :
        status === "pending" ? "bg-yellow-500" :
        (status === "paid" || status === "completed" || status === "succeeded") ? "bg-green-500" : "bg-gray-400"
      }`}></span>
      {status}
    </span>
  );
};

const DetailItem = ({ label, value }) => (
    <div className="py-2">
        <p className="text-sm text-gray-500">{label}</p>
        <p className="text-md font-semibold text-gray-800">{value}</p>
    </div>
);

export default function PaymentDetailPage() {
  const { id } = useParams();
  const [payment, setPayment] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPayment = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchData(`finance/payments/${id}`);
        setPayment(data.data);
      } catch (err) {
        setError(err.message || "حدث خطأ أثناء جلب البيانات");
      } finally {
        setLoading(false);
      }
    };

    fetchPayment();
  }, [id]);

  if (loading) {
    return <div className="text-center mt-4">جاري التحميل...</div>;
  }

  if (error) {
    return <div className="text-red-600 text-center mt-4">{error}</div>;
  }

  if (!payment) {
    return <div className="text-center mt-4">لم يتم العثور على الدفعة.</div>;
  }

  return (
    <div className="min-h-screen p-4 md:p-6 bg-white" dir="rtl">
      <PageHeader title={`تفاصيل الدفعة #${payment.id}`} />
      <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <DetailItem label="ID" value={payment.id} />
            <DetailItem label="بوابة الدفع" value={payment.gateway} />
            <DetailItem label="المرجع" value={payment.reference} />
            <DetailItem label="المبلغ" value={`${payment.amount} ${payment.currency}`} />
            <DetailItem label="الحالة" value={<StatusPill status={payment.status} />} />
            <DetailItem label="تاريخ الإنشاء" value={new Date(payment.created_at).toLocaleString()} />
            <DetailItem label="آخر تحديث" value={new Date(payment.updated_at).toLocaleString()} />
            <DetailItem label="رمز المعاملة" value={payment.transaction_code} />
        </div>
        {payment.metadata && (
            <div className="mt-6">
                <h3 className="text-lg font-bold mb-2">بيانات إضافية (Metadata)</h3>
                <pre className="bg-gray-100 p-4 rounded-md text-sm overflow-x-auto">
                    {JSON.stringify(payment.metadata, null, 2)}
                </pre>
            </div>
        )}
      </div>
    </div>
  );
}
